<ng-container *ngIf="!!product">
  <div class="row">
    <div class="col-12 col-md-7">
      <div class="border shadow-sm bg-white p-5 h-100">
        <div class="row h-100">
          <div class="col-12 mb-2" *ngIf="!!product.extra.images">
            <ngb-carousel #myCarousel [interval]="-1" [showNavigationIndicators]="false" [showNavigationArrows]="false">
              <ng-template ngbSlide *ngFor="let image of product.extra.images; let i = index" [id]="imageIdString + i">
                <div class="square">
                  <div class="content">
                    <div class="d-flex justify-content-center align-items-flex-start h-100">
                      <img class="img-fluid"
                        [src]="image.s3Uri | gungImageUrl: 'type:detail' : 'etag:' + image.s3ETag : 'size:2000x2000'"
                        alt="{{ image.description }}" />
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-carousel>
          </div>
          <div class="col-12">
            <div class="scolling-images">
              <a class="scroll-left" (click)="scrollImagesLeft()">
                <i class="fa fa-2x fa-caret-left"></i>
              </a>
              <div class="scroll-container row" #scrollContainer>
                <div class="col-4 d-flex justify-content-center align-items-center"
                  [ngClass]="{ 'pr-0': index == product.extra.images.length - 1 }"
                  *ngFor="let image of product.extra.images; let i = index">
                  <img (click)="select(i)" class="img-fluid" src="https://cdn1.gung.io/fit-in/500x500/filters:fill(white):background_color(white):etag({{
                      image.s3ETag
                    }}):format(jpeg)/{{ image.s3Uri }}" alt="{{ image.description }}" />
                </div>
              </div>
              <a class="scroll-right" (click)="scrollImagesRight()">
                <i class="fa fa-2x fa-caret-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-5" *ngIf="!!product">
      <div class="border shadow-sm bg-white p-5 h-100">
        <div class="row">
          <div class="col">
            <h2 class="mb-1 pb-3 border-bottom gray">
              <b>{{ product.id }} - {{ product.name }}</b>
            </h2>
            @if (!hidePrices) {
            @if (displayStaffedPrices && price) {
            <hl-display-price [price]="price" priceLevelsDisplayType="FULL" displayOnlyPrice="true"
              type="STAFFED" [currentQty]="product?.extra?.minimumOrderQuantity"></hl-display-price>
            } @else {
            <span *ngIf="price" class="text-nowrap d-block h3 m-0 mt-4 blue font-weight-bold">
              {{
              price.customerGrossPrice.value
              | gungCurrency: price.customerGrossPrice.currencyCode : 'symbol-narrow' : '1.2-2'
              }}
              <span *ngIf="displayDiscountFromPriceList && price?.backendPrice?.levels?.[0]?.extra?.prl?.proc1 > 0"
                class="text-disc">(-{{ price.backendPrice.levels[0].extra.prl.proc1 }}%)</span>
            </span>
            }
            }
            <span *ngIf="availability" class="d-flex align-items-center light-gray">
              <!-- <i class="fas fa-circle fa-xs mr-3"></i> -->
              <app-hl-display-availability [availability]="availability"></app-hl-display-availability>
            </span>
            <div class="d-flex mt-4 mb-2 icon-row">
              <app-hl-display-favourite-product-icon class="product-info-icon" [id]="product.id"></app-hl-display-favourite-product-icon>
              @if (product.extra?.hlVideos?.[0]?.videoUrl) {
                <a class="product-info-icon" [href]="product.extra.hlVideos[0].videoUrl" target="_blank" [title]="'VIDEO' | translate">
                  <i class="fa-regular fa-circle-play"></i>
                </a>
              } @else {
                <span class="product-info-icon disabled">
                  <i class="fa-regular fa-circle-play"></i>
                </span>
              }
              @if (product.extra?.documents?.[0]) {
                <a class="product-info-icon" [href]="product.extra.documents[0] | gungDownloadUrl" target="_blank" [title]="'DOCUMENT' | translate">
                  <i class="fa-regular fa-file-lines"></i>
                </a>
              } @else {
                <span class="product-info-icon disabled">
                  <i class="fa-regular fa-file-lines"></i>
                </span>
              }
            </div>
            <app-hl-display-buy-btn [product]="product" [id]="product.id"
              [price]="price"></app-hl-display-buy-btn>
            <h3 class="mt-4 blue" translate>DESCRIPTION</h3>
            @if (isCustomerService) {
            <p class="mt-2 mb-0 gray">{{ product.extra.i18n[currentLang].internalProductName }}</p>
            <p class="mb-0 gray">{{ product.extra?.ar?.q_hl_ext_item_number }}</p>
            } @else {
            <p class="mt-2 gray">{{ product.extra.i18n[currentLang].itemspecweb }}</p>
            }
            <ul class="component-list light-gray" *ngIf="components && components.length > 0">
              <li *ngFor="let component of components">
                {{ componentAmounts[component.id] }} {{ component.name }} ({{ component.id }})
              </li>
            </ul>
            <h3 class="mt-4 blue" translate>SPECIFICATION</h3>
            <div class="product-info-table mt-2 light-gray">
              <div class="table-responsive">
                <table class="table table-sm table-striped">
                  <tbody>
                    <tr *ngIf="!!product.extra.hlPimItem.ItemShelfLength">
                      <th class="w-auto">
                        <span translate>LENGTH</span>
                      </th>
                      <td class="w-75">
                        {{ product.extra.hlPimItem.ItemShelfLength }}
                      </td>
                    </tr>
                    <tr *ngIf="!!product.extra.hlPimItem.ItemDepthmm">
                      <th class="w-auto">
                        <span translate>DEPTH</span>
                      </th>
                      <td class="w-75">
                        {{ product.extra.hlPimItem.ItemDepthmm }}
                      </td>
                    </tr>
                    <tr *ngIf="
                        !!product.extra.hlPimItem.ItemColourName &&
                        hlDisplayMetadataHelperService.getProductColours(product) != ''
                      ">
                      <th class="w-auto">
                        <span translate>COLOUR</span>
                      </th>
                      <td class="w-75">
                        {{ hlDisplayMetadataHelperService.getProductColours(product) }}
                      </td>
                    </tr>
                    <tr *ngIf="!!product.extra.stepAmount">
                      <th class="w-auto">
                        <span translate>PACKAGE_SIZE</span>
                      </th>
                      <td class="w-75">
                        {{ product.extra.stepAmount }}
                      </td>
                    </tr>
                    <tr *ngIf="!!product.extra.hlPimItem?.NumberPerBox && !product.extra.stepAmount">
                      <th class="w-auto">
                        <span translate>PACK_SIZE</span>
                      </th>
                      <td class="w-75">
                        {{ product.extra.hlPimItem.NumberPerBox }}
                      </td>
                    </tr>
                    @if (isCustomerService || isSales) {
                    <tr>
                      <th class="w-auto" translate>CC_PRICE</th>
                      <td class="w-75">{{ product.extra?.ar?.artkalkber | number: '1.0-2' }}</td>
                    </tr>
                    @if (isCustomerService) {
                    <tr>
                      <th class="w-auto" translate>COST_ADDED_VALUE_ITEM</th>
                      <td class="w-75">{{ ((product.extra?.ar?.artkalkber || 0) - (product.extra?.ar?.q_average_tf ||
                        0)) | number: '1.0-2' }} </td>
                    </tr>
                    }
                    <tr>
                      <th class="w-auto" translate>BASE_COST_SALES_START</th>
                      <td class="w-75">
                        {{
                        (product.extra?.ar?.q_basecost_start | number: '1.2-2') + (baseCostCurrency ? (' ' +
                        baseCostCurrency) : '')
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th class="w-auto" translate>BASE_COST_SALES_UNIT</th>
                      <td class="w-75">
                        {{
                        (product.extra?.ar?.q_basecost_unit | number: '1.2-2') + (baseCostCurrency ? (' ' +
                        baseCostCurrency) : '')
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th class="w-auto" translate>MOQ</th>
                      <td class="w-75">{{ product.extra?.ar?.q_hl_sales_moq | number: '1.0-2' }}</td>
                    </tr>
                    <tr>
                      <th class="w-auto" translate>EOQ</th>
                      <td class="w-75">{{ arsForMainWarehouse?.eoq | number: '1.0-2' }}</td>
                    </tr>
                    <tr>
                      <th class="w-auto" translate>ROP_REORDER_POINT</th>
                      <td class="w-75">{{ arsForMainWarehouse?.lagbestpkt | number: '1.0-2' }}</td>
                    </tr>
                    @if (isCustomerService) {
                    <tr>
                      <th class="w-auto" translate>ACQUISITION_METHOD</th>
                      <td class="w-75">
                        <lib-gung-meta-output [horizontal]="true" [showOnlyText]="true"
                          [gungTranslate]="'ACQUISITION_METHOD'" [value]="product.extra?.ar?.anskaffningssatt"
                          metadataTable="xaas" metaOptionName="anskaffningssattbeskr">
                        </lib-gung-meta-output>
                      </td>
                    </tr>
                    <tr>
                      <th class="w-auto" translate>NET_WEIGHT_KG</th>
                      <td class="w-75">{{ product.extra?.ar?.artvikt | number: '1.0-4' }}</td>
                    </tr>
                    }
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row pt-3" *ngIf="isCustomerService">
    <div class="col-12 col-md-7"></div>
    <div class="col-12 col-md-5">
      <div class="border shadow-sm bg-white p-5">
        <hl-display-availability-report [productId]="product.id" />
      </div>
    </div>
  </div>
</ng-container>
